<script setup lang="ts">
import { inject } from 'vue'

const isReauthMode = inject<boolean>('reauthMode', false)

const title = isReauthMode ? 'reauthForm.title' : 'form.title'
</script>

<template>
  <h1 data-testid="form-title" class="h4 mb-4 text-balance">{{ $t(title) }}</h1>
</template>
